import { getYear, packArgs, spread } from '@/utils'
import { add, adjust, map, pipe, range, reverse } from 'ramda'

export const getYears: (minDate: Date, maxDate: Date) => string[] = pipe(
  packArgs(map(getYear)),
  //@ts-expect-error fix after removing ramda
  adjust(1, add(1)),
  spread(range),
  reverse,
)
